import React, { useRef, useState, useEffect } from 'react';
import { PathRouteProps } from 'react-router';

import Header from '../../components/header/header';
import Hero from '../../components/hero/hero';
import Clients from '../../components/clients/clients';
import About from '../../components/about/about';
import Tech from '../../components/tech/tech';
import Services from '../../components/services/services';
import Process from '../../components/process/process';
import Projects from '../../components/projects/projects';
import Faq from '../../components/faq/faq';
import Contact from '../../components/contact/contact';
import Preloader from '../../components/preloader/preloader';
import BackToTop from '../../components/backtotop/backtotop';
import Footer from '../../components/footer/footer';
import PopupContent, { PopupContentItem } from '../../components/popup-content/popup-content';
import Privacy from '../../components/privacy/privacy';
import Callback from '../../components/callback/callback';

import './home.scss';

type HeaderRef = React.ElementRef<typeof Header>;

interface HomeRouteProps extends PathRouteProps {
}

const HomeRoute: React.FC<HomeRouteProps> = (props: HomeRouteProps) => {
  
  const [ loading, setLoading ] = useState<boolean>(true);

  const headerRef = React.useRef<HeaderRef>(null);

  const heroRef = useRef(null);
  const clientsRef = useRef(null);
  const aboutRef = useRef(null);
  const techRef = useRef(null);
  const servicesRef = useRef(null);
  const processRef = useRef(null);
  const projectsRef = useRef(null);
  const faqRef = useRef(null);
  const contactRef = useRef(null);

  useEffect(() => {
    setLoading(false);
  }, []); 

  return (
    <React.Fragment>
      <Header 
        ref={headerRef}
        navRefs={{
          hero: heroRef,
          clients: clientsRef,
          about: aboutRef,
          tech: techRef,
          services: servicesRef,
          process: processRef,
          projects: projectsRef,
          faq: faqRef,
          contact: contactRef
        }}
      />
      <Hero ref={heroRef} headerRef={headerRef} />
      <main>
        <Clients ref={clientsRef} />
        <About ref={aboutRef} />
        <Tech ref={techRef} />
        <Services ref={servicesRef} />
        <Process ref={processRef} headerRef={headerRef} />
        <Projects ref={projectsRef} />
        <Faq ref={faqRef} />
        <Contact ref={contactRef} />
        <PopupContent>
          <PopupContentItem hash="privacy-policy" content={<Privacy />} />
          <PopupContentItem hash="callback" content={<Callback />} closeHref="#contact" />
        </PopupContent>
      </main>
      <BackToTop />
      {loading && <Preloader />}
      <Footer />
    </React.Fragment>
  );
};

export default HomeRoute;